import { oauthHandleNew } from "src/welcome/data-access/gateway";
import { useQuery } from "react-query";
import { enqueueSnackbar } from "notistack";
import { AxiosError } from "axios";
import { useTranslation } from "react-i18next";
import { useAuth } from "src/shared/context/useAuth";
import { useNavigate } from "react-router-dom";
import DangerouslySetHtmlContent from "dangerously-set-html-content";
import React from "react";

export const useOauthHandleNew = (
  mode: string | null,
  code: string | null,
  state: string | null,
  errorDescription: string | null,
  enabled: boolean,
) => {
  const { t } = useTranslation();
  const { userHomePath } = useAuth();
  const navigate = useNavigate();
  return useQuery({
    queryKey: ["oauthHandle"],
    queryFn: () => oauthHandleNew(mode, code, state, errorDescription),
    enabled: enabled,
    onSuccess: (data) => {
      window.location.href = data?.data?.url;
    },
    onError: (error: AxiosError<any>) => {
      enqueueSnackbar(
        <div>
          {error.response?.data ? (
            <DangerouslySetHtmlContent html={error.response?.data} />
          ) : (
            t(
              "Συνέβη κάποιο σφάλμα συστήματος, παρακαλούμε προσπαθήστε ξανά αργότερα.",
            )
          )}
        </div>,
        { variant: "error" },
      );
      navigate(userHomePath);
    },
  });
};
